import React, { useState, useEffect, useCallback } from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import FilterListIcon from "@material-ui/icons/FilterList";
import BannerMentora from "./sisef/ui/BannerMentora";
import AccionesRapidasMentora from "./sisef/ui/AccionesRapidasMentora";
import emma_s1 from "./../../global/imagenes/emma_s1.png";
import { consulta, obtenerValoresFiltros } from "../../global/js/funciones";
import TareasTerminadas from "../general/TareasTerminadas";
import TituloAccion from "../general/TituloAccion";
import AsignaturaPlaneador from "./sisef/AsignaturaPlaneador";
import NavActionsMentora from "./sisef/ui/NavActionsMentora";
import { useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import ConfirmarAccion from "../general/ConfirmarAccion";

const COLOR_MAP = {
  0: { backgroundColor: "#f5f5f5", color: "#757575" },
  1: { backgroundColor: "#ffc107", color: "white" },
  2: { backgroundColor: "#009688", color: "white" },
  3: { backgroundColor: "#0d47a1", color: "white" },
  4: { backgroundColor: "#02A6F2", color: "white" },
  5: { backgroundColor: "#e65100", color: "white" },
  6: { backgroundColor: "#6200ea", color: "white" },
  7: { backgroundColor: "#bdbdbd", color: "white" },
  8: { backgroundColor: "#F5951B", color: "white" },
  9: { backgroundColor: "#b71c1c", color: "white" },
  default: { backgroundColor: "#f5f5f5", color: "#757575" },
};

const getAvatarColors = (index) => {
  const key = index % 10;
  return COLOR_MAP[key] || COLOR_MAP.default;
};

const MentoraPlaneador = ({ cambiarOpcion }) => {
  const usuario = useSelector(state => state.redGlobal.usuario);
  const [vista, setVista] = useState("inicio");
  const [asignaturas, setAsignaturas] = useState([]);
  const [codigoBusqueda, setCodigoBusqueda] = useState("");
  const [buscando, setBuscando] = useState(false);
  const [yaBusco, setYaBusco] = useState(false);
  const [periodo, setPeriodo] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [asignaturaSeleccionada, setAsignaturaSeleccionada] = useState(null);
  const [mostrarConfirmarPlaneador, setMostrarConfirmarPlaneador] = useState(false);
  const [planeadorPendiente, setPlaneadorPendiente] = useState(null);
  const [validandoPlaneador, setValidandoPlaneador] = useState(false);
  const esAdmin = usuario?.perfil?.codigo === "Per_Adm" || usuario?.perfil?.codigo == "coor_area_sisef"
  const esDocente = usuario?.perfil?.codigo === "Per_Doc";

  useEffect(() => {
    const cargarPeriodo = async () => {
      try {
        let data_periodo = await obtenerValoresFiltros([
          { llave: "codigo", valor: "Per_Sisef" },
          { llave: "estado", valor: "1" }
        ]);
        if (data_periodo && data_periodo.length > 0) {
          setPeriodo(data_periodo[0].nombre);
        }
      } catch (e) {
        console.error("Error obteniendo periodo", e);
      }
    };

    cargarPeriodo();
  }, []);

  const ObtenerAsignaturas = useCallback((periodoSeleccionado) => {
    return new Promise((resolve) => {
      consulta(
        `api/v1.0/sisef/docente_asignaturas/${0}/${periodoSeleccionado}/${0}`,
        null,
        null,
        (error, estado, resp) => {
          if (!error && estado === 200) {
            resolve(resp || []);
          } else {
            resolve([]);
          }
        }
      );
    });
  }, []);

  const BuscarPlanAsignatura = useCallback((codigo) => {
    return new Promise((resolve) => {
      consulta(
        `api/v1.0/sisef/plan-asignatura/buscar?codigo=${codigo}`,
        null,
        null,
        (error, estado, resp) => {
          if (!error && estado === 200) {
            resolve(resp || []);
          } else {
            resolve([]);
          }
        }
      );
    });
  }, []);

  const validarPlaneadorEjecucionAdmin = (planId, periodo) => {
    return new Promise((resolve) => {
      consulta(
        `api/v1.0/sisef/planeador/ejecucion/validar/${planId}/${periodo}/`,
        null,
        "get",
        (error, estado, resp) => {
          if (!error && estado === 200) resolve(resp);
          else resolve(null);
        }
      );
    });
  };

  const validarPlaneadorEjecucionDocente = (docenteAsignaturaId, periodo) => {
    return new Promise((resolve) => {
      consulta(
        `api/v1.0/sisef/planeador/ejecucion/validar-docente/${docenteAsignaturaId}/${periodo}/`,
        null,
        "get",
        (error, estado, resp) => {
          if (!error && estado === 200) resolve(resp);
          else resolve(null);
        }
      );
    });
  };

  const crearPlaneadorEjecucion = useCallback((payload) => {
    return new Promise((resolve) => {
      consulta(
        "api/v1.0/sisef/planeador/ejecucion/crear/",
        payload,
        "post",
        (error, estado, resp) => {
          if (!error && (estado === 200 || estado === 201)) {
            resolve(resp);
          } else {
            resolve(null);
          }
        }
      );
    });
  }, []);

  const obtenerContextoPlaneadorDocente = useCallback((docenteAsignaturaId, periodo) => {
    return new Promise((resolve) => {
      consulta(
        `api/v1.0/sisef/planeador/ejecucion/contexto/${docenteAsignaturaId}/${periodo}/`,
        null,
        "get",
        (error, estado, resp) => {
          if (!error && estado === 200) resolve(resp);
          else resolve(null);
        }
      );
    });
  }, []);

  useEffect(() => {
    let isMounted = true;
    if (esAdmin) {
      setAsignaturas([]);
      setCargando(false);
      return () => {
        isMounted = false;
      };
    }
    setCargando(true);
    ObtenerAsignaturas(periodo)
      .then((data) => {
        if (!isMounted) return;
        setAsignaturas(data || []);
        setCargando(false);
      })
      .catch(() => {
        if (!isMounted) return;
        setAsignaturas([]);
        setCargando(false);
      });
    return () => {
      isMounted = false;
    };
  }, [ObtenerAsignaturas, periodo, esAdmin]);

  const handleRegresar = useCallback(
    (valorVista) => {
      const vistasLocales = ["inicio", "asignatura"];
      const destino = valorVista || (typeof cambiarOpcion === "function" ? "miproceso_ini" : "inicio");
      if (vistasLocales.includes(destino)) setVista(destino);
      else if (typeof cambiarOpcion === "function") cambiarOpcion(destino);
    },
    [cambiarOpcion]
  );

  const renderContenidoAsignaturas = () => {
    if (cargando) {
      return (
        <TareasTerminadas
          mensaje="Cargando asignaturas..."
          marginTop="7%"
          imagen={emma_s1}
          widthImg="7%"
          cargando={true}
        />
      );
    }

    if (asignaturas.length === 0) {
      return (
        <TareasTerminadas
          mensaje="Aún no tiene asignaturas a cargo para este periodo."
          marginTop="7%"
          imagen={emma_s1}
          widthImg="7%"
          cargando={false}
        />
      );
    }

    return (
      <Grid container direction="row" spacing={1} style={{ width: "100%" }}>
        {asignaturas.map(
          ({ id, nombre_asignatura: nombre, codigo_asignatura: codigo }, i) => (
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              key={codigo || i}
              onClick={async () => {
                const esAsignaturaDocente = Boolean(asignaturas[i]?.docente);
                // ADMIN → ENTRA DIRECTO
                if (!esAsignaturaDocente) {
                  setAsignaturaSeleccionada(id);
                  setVista("asignatura");
                  return;
                }
                // DOCENTE → VALIDAR
                setValidandoPlaneador(true);
                const resp = await validarPlaneadorEjecucionDocente(id, periodo);
                setValidandoPlaneador(false);
                // Ya existe ejecución
                if (resp?.existe) {
                  const contexto = await obtenerContextoPlaneadorDocente(id, periodo);
                  if (!contexto) return;
                  setAsignaturaSeleccionada({
                    esDocente: true,
                    planeadorEjecucionId: contexto.planeador_ejecucion_id,
                    planeadorBaseId: contexto.planeador_base_id,
                    planAsignatura: contexto.plan_asignatura
                  });
                  setVista("asignatura");
                  return;
                }
                // No existe → mostrar confirmar
                setPlaneadorPendiente({
                  docenteAsignaturaId: id,
                  planId: resp?.plan_id
                });
                setMostrarConfirmarPlaneador(true);
              }}
            >
              <AccionesRapidasMentora
                imagen=""
                titulo={nombre.toUpperCase()}
                sub_titulo=""
                des_sub_titulo={codigo}
                avatar={getAvatarColors(i)}
                avatar_name={nombre.charAt(0).toUpperCase()}
              />
            </Grid>
          )
        )}
      </Grid>
    );
  };

  const renderVistaAsignaturas = () => {
    let mostrarContenidoAdmin = false;
    let mensajeAdmin = "";
    let cargandoAdmin = false;
    if (buscando) {
      mensajeAdmin = "Buscando asignatura...";
      cargandoAdmin = true;
    } else if (!yaBusco) {
      mensajeAdmin =
        "Ingrese el código de la asignatura en el buscador y presione Buscar.";
    } else if (asignaturas.length === 0) {
      mensajeAdmin = "No se encontró ninguna asignatura con ese código.";
    } else {
      mostrarContenidoAdmin = true;
    }
    return (
      <div style={{ padding: "20px 2% 0 2%" }}>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={10}>
            <BannerMentora
              nombre={nombreUsuario}
              informacion="Bienvenido al módulo de planeación docente, aquí podrás gestionar las asignaturas que tienes a cargo."
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={10}>
            <div style={{ marginTop: 15, marginBottom: 18 }}>
              <Grid
                container
                alignItems="center"
                justifyContent="space-between"
              >
                <NavActionsMentora onBack={() => handleRegresar()} />
                {esAdmin && (
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      height: 40,
                      borderRadius: 14,
                      border: "1px solid rgba(0,0,0,0.10)",
                      background: "#fff",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: 10,
                        paddingRight: 10,
                        height: "100%",
                      }}
                    >
                      <SearchIcon
                        style={{
                          fontSize: 20,
                          color: "#b71c1c",
                          marginRight: 6,
                        }}
                      />
                      <input
                        type="text"
                        value={codigoBusqueda}
                        onChange={(e) => {
                          setCodigoBusqueda(e.target.value);
                          setYaBusco(false);
                        }}
                        placeholder="Código de la asignatura"
                        style={{
                          border: "none",
                          outline: "none",
                          fontSize: 13,
                          height: "100%",
                          width: 260,
                        }}
                      />
                    </div>
                    <div
                      style={{
                        width: 1,
                        height: 24,
                        background: "rgba(0,0,0,0.10)",
                      }}
                    />

                    {/* BOTÓN BUSCAR */}
                    <button
                      disabled={buscando}
                      onClick={async () => {
                        if (!codigoBusqueda) return;
                        setBuscando(true);
                        setYaBusco(true);
                        const resultado = await BuscarPlanAsignatura(codigoBusqueda);
                        setAsignaturas(resultado);
                        setBuscando(false);
                      }}
                      style={{
                        height: "100%",
                        padding: "0 14px",
                        border: "none",
                        background: "transparent",
                        fontWeight: 800,
                        fontSize: 13,
                        color: "#b71c1c",
                        cursor: "pointer",
                      }}
                    >
                      BUSCAR
                    </button>
                  </div>
                )}
              </Grid>
            </div>
            <Paper elevation={0} square className="scroll contenido_fijo">
              {!esAdmin && renderContenidoAsignaturas()}
              {esAdmin &&
                (mostrarContenidoAdmin ? (
                  renderContenidoAsignaturas()
                ) : (
                  <TareasTerminadas
                    mensaje={mensajeAdmin}
                    marginTop="6%"
                    imagen={emma_s1}
                    widthImg="6%"
                    cargando={cargandoAdmin}
                  />
                ))}
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  };

  const renderVista = () => {
    switch (vista) {
      case "inicio":
        return renderVistaAsignaturas();
      case "asignatura":
        return <AsignaturaPlaneador handleRegresar={handleRegresar} idPlanSyll={asignaturaSeleccionada} esDocente={esDocente} />;
      default:
        return null;
    }
  };

  const nombreUsuario = [usuario?.primer_nombre, usuario?.segundo_nombre, usuario?.primer_apellido, usuario?.segundo_apellido].filter(Boolean).join(" ");

  return (
    <>
      {renderVista()}

      <ConfirmarAccion
        titulo="Registrar planeador"
        dato={{ id: planeadorPendiente?.planId || 0 }}
        mensaje1="No existe un planeador de ejecución para este periodo."
        mensaje2="¿Desea crearlo ahora?"
        modalConAccion={mostrarConfirmarPlaneador}
        mostrarModalConfAccion={(resp) => setMostrarConfirmarPlaneador(resp)}
        ejecutarAccion={async () => {
          if (!planeadorPendiente) return;
          const resp = await crearPlaneadorEjecucion({
            plan_id: planeadorPendiente.planId,
            periodo
          });
          setMostrarConfirmarPlaneador(false);
          if (resp?.ok) {
            const contexto = await obtenerContextoPlaneadorDocente(
              planeadorPendiente.docenteAsignaturaId,
              periodo
            );
            if (!contexto) return;
            setAsignaturaSeleccionada({
              esDocente: true,
              planeadorEjecucionId: contexto.planeador_ejecucion_id,
              planeadorBaseId: contexto.planeador_base_id,
              planAsignatura: contexto.plan_asignatura
            });
            setVista("asignatura");
          }
        }}
      />
      {validandoPlaneador && (
        <TareasTerminadas
          mensaje="Validando planeador..."
          marginTop="6%"
          imagen={emma_s1}
          widthImg="6%"
          cargando
        />
      )}
    </>
  )
};

export default MentoraPlaneador;
